enum CustomerVisitsColor {
  "Stockist" = "#896187",
  "Semi" = "#B8B3D6",
  "Retailer" = "#778EBC",
  "Healthcare Provider" = "#6A5F6F",
  "Hub Chemist" = "#B68D67",
}
export default CustomerVisitsColor;
